import React, { useEffect, useRef } from "react";

export default function StarField() {
  const ref = useRef(null);

  useEffect(() => {
    const colors = ["#ffffff", "#ff3b3b", "#0be881", "#ffa500"];
    const container = ref.current;

    function trigger() {
      if (!container) return;
      container.innerHTML = "";
      for (let i = 0; i < 25; i++) {
        const star = document.createElement("div");
        star.className = "star";
        const c = colors[Math.floor(Math.random() * colors.length)];
        star.style.backgroundColor = c;
        star.style.boxShadow = `0 0 8px ${c}, 0 0 15px ${c}`;
        const size = Math.random() * 2 + 2;
        star.style.width = size + "px";
        star.style.height = size + "px";
        star.style.left = Math.random() * 100 + "vw";
        star.style.animationDuration = Math.random() * 5 + 6 + "s";
        star.style.animationDelay = Math.random() * 2 + "s";
        star.style.animationName = i % 2 === 0 ? "fallDown" : "floatUp";
        star.style.animationIterationCount = "infinite";
        star.style.animationTimingFunction = "linear";
        container.appendChild(star);
      }
    }

    trigger();
    const interval = setInterval(trigger, 13000);
    return () => clearInterval(interval);
  }, []);

  return <div className="star-container" ref={ref} data-testid="star-field" />;
}
